<template lang="html">
  <v-container grid-list-md mt-0 pt-0>
    <div class="ta-c mb-4">
      <img src="../assets/images/logo_plant3.png" alt="" class="logo-size" />
    </div>
    <v-layout row wrap justify-center>
      <div class="ta-c">
        <span class="display-1 font-weight-bold ">เข้าสู่ระบบ</span>
      </div>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex md6 xs12 sm6 class="mt-2">
        <v-text-field
          label="รหัสบัตรประชาชน"
          prepend-inner-icon="person"
          solo
          hide-details
          color="blue"
          :mask="mask"
          :rule="nameRules"
          v-model="card_id"
          @keyup.enter="login()"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center mt-3>
      <v-flex md2 xs4>
        <div class="ta-c">
          <v-btn
            color="primary"
            round
            block
            class="mx-0"
            :loading="loading"
            @click="login()"
            >เข้าสู่ระบบ</v-btn
          >
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center mt-1>
      <v-flex md12 xs12>
        <div class="ta-c">
          <span class="title font-weight-bold"
            >ท่านที่ยังไม่ได้ลงทะเบียน กรุณาลงทะเบียน<br
          /></span>
        </div>
      </v-flex>
      <v-flex md6 xs12>
        <div class="ta-c pointer indigo--text" @click="gotoRegister()">
          <v-icon class="mr-2 indigo--text">perm_identity</v-icon
          ><span class="title font-weight-bold underline  pb-1"
            >ลงทะเบียนในนามบุคคล</span
          ><br />
        </div>
        <div
          class="ta-c mt-2 pointer indigo--text"
          @click="gotoRegisterCompany()"
        >
          <v-icon class="mr-2 indigo--text">business</v-icon
          ><span class="title font-weight-bold"
            ><span class="underline"
              >ลงทะเบียนกรณีหน่วยงานราชการ/องค์กร/บริษัท/อื่นๆ</span
            ></span
          >
        </div>
        <div
          class="ta-c mt-2 pointer indigo--text"
          @click="gotoRegisterStudentLoan()"
        >
          <v-icon class="mr-2 indigo--text">school</v-icon
          ><span class="title font-weight-bold"
            ><span class="underline">ลงทะเบียนกรณีผู้กู้ยืมกยศ.</span></span
          >
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 md12 lg12>
        <div style="width:100%;text-align:center;">
          <v-btn
            flat
            round
            href="https://plant.forest.go.th/static/plant-knowledge/manual.pdf"
            target="_blank"
            ><v-icon class="mr-1">chrome_reader_mode</v-icon
            >คู่มือการใช้งาน</v-btn
          >
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Encode } from "@/services";
export default {
  data() {
    return {
      mask: "#############",
      nameRules: [(v) => !!v || "Name is required"],
      card_id: "",
      loading: false,
      company: ""
    };
  },
  methods: {
    gotoRegister() {
      this.$router.push("/register");
    },
    gotoRegisterCompany() {
      this.$router.push("/register/company");
    },
    gotoRegisterStudentLoan() {
      this.$router.push("/register/studentloan");
    },
    login() {
      this.loading = true;
      if (this.card_id !== "") {
        this.axios
          .post(process.env.VUE_APP_IPFLASK + "/login", {
            card_id: this.card_id
          })
          .then((response) => {
            if (response.data !== "Not found id card") {
              // console.log(response.data)
              this.listInformation = response.data;
              this.card_id = this.listInformation[0].card_id;
              this.name = this.listInformation[0].name;
              // if company no value company = null
              this.company = this.listInformation[0].company;
              this.academy = this.listInformation[0].academy;
              if (this.company !== null) {
                var company_encode = Encode.encode({ company: this.company });
              } else {
                company_encode = Encode.encode({ company: "" });
              }

              if (this.academy !== null) {
                var academy_encode = Encode.encode({ academy: this.academy });
              } else {
                academy_encode = Encode.encode({ academy: "" });
              }
              // console.log(this.company);
              var fullName =
                this.listInformation[0].title +
                this.listInformation[0].name +
                " " +
                this.listInformation[0].surname;
              // console.log(fullName);
              // var card_id = bcrypt.hashSync(this.card_id, process.env.SALT);
              // var name = bcrypt.hashSync(this.name, process.env.SALT);
              // console.log(card_id);
              var cardid_encode = Encode.encode({ card_id: this.card_id });
              var fullName_encode = Encode.encode({ fullName: fullName });
              // var name_encode = Encode.encode({'name': this.name})
              this.$cookies.set(
                "token",
                cardid_encode,
                "1d",
                "/",
                process.env.WEB
              );
              this.$cookies.set(
                "company",
                company_encode,
                "1d",
                "/",
                process.env.WEB
              );
              this.$cookies.set(
                "academy",
                academy_encode,
                "1d",
                "/",
                process.env.WEB
              );
              this.$cookies.set("name", this.name, "1d", "/", process.env.WEB);
              this.$cookies.set(
                "fullName",
                fullName_encode,
                "1d",
                "/",
                process.env.WEB
              );
              // console.log(this.name);
              this.$emit("getUsername", this.name);
              this.$router.push("/seeding");
              this.loading = false;
            } else {
              this.$swal(
                "ไม่พบรหัสบัตรประชาชนนี้ในระบบ",
                "กรุณาตรวจสอบรหัสบัตรประชาชนหรือลงทะเบียนอีกครั้ง",
                "error"
              );
              this.loading = false;
            }
          });
      } else {
        this.$swal("กรุณากรอกรหัสบัตรประชาชน เพื่อเข้าสู่ระบบ", "", "error");
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 320px) {
  .logo-size {
    width: 70px;
    height: 70px;
  }
}

@media only screen and (min-width: 321px) and (max-width: 600px) {
  .logo-size {
    width: 90px;
    height: 90px;
  }
}

@media only screen and (min-width: 601px) and (max-width: 960px) {
  .logo-size {
    width: 90px;
    height: 90px;
  }
}

@media only screen and (min-width: 961px) {
  .logo-size {
    width: 100px;
    height: 100px;
  }
}
</style>
